import DatePickerCalendarCard from "shared/components/date-controls/holidays-calendar/DatePickerCalendarCard";
import PropTypes from "prop-types";
import React from "react";
import { useDatePicker } from "@react-aria/datepicker";
import { useDatePickerState } from "@react-stately/datepicker";

export const Calendar = ({ holidaysList = [], ...props }) => {
    const datePickerState = useDatePickerState(props);
    const ref = React.useRef();
    const { calendarProps } = useDatePicker(props, datePickerState, ref);

    return (
        <DatePickerCalendarCard
            {...calendarProps}
            holidaysList={holidaysList}
        />
    );
};

Calendar.propTypes = {
    holidaysList: PropTypes.array,
};
